module.exports = __webpack_public_path__ + "media/images/2-highlighted-e8139662.png";